"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Skeleton", {
  enumerable: true,
  get: function get() {
    return _skeletonVariants.Skeleton;
  }
});
Object.defineProperty(exports, "SkeletonCircle", {
  enumerable: true,
  get: function get() {
    return _skeletonVariants.SkeletonCircle;
  }
});
Object.defineProperty(exports, "SkeletonText", {
  enumerable: true,
  get: function get() {
    return _skeletonVariants.SkeletonText;
  }
});
Object.defineProperty(exports, "SkeletonTheme", {
  enumerable: true,
  get: function get() {
    return _skeletonTheme.SkeletonTheme;
  }
});
var _skeletonTheme = require("./skeleton-theme");
var _skeletonVariants = require("./skeleton-variants");